import { createSelector } from 'reselect';
import { uninitState, statusSuccess, idleState } from '@grandvisionhq/state';
import { getCheckout } from '../selectors.js';
import { isUninitialized } from '../state.js';
import { ViewMode } from './state.js';

const getAddressBook = createSelector(getCheckout, (checkout)=>!isUninitialized(checkout) ? checkout.addressBook : undefined
);
const getAddressBookList = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.list : uninitState()
);
createSelector(getAddressBook, (addressBook)=>addressBook && statusSuccess(addressBook.list) ? addressBook.list.result.length : undefined
);
const getAddCall = createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.calls.add : idleState()
);
createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.calls.edit : idleState()
);
createSelector(getAddressBook, (addressBook)=>addressBook ? addressBook.modalState : {
        isOpen: false,
        viewMode: ViewMode.ADD
    }
);
createSelector(getAddressBook, (addressBook)=>{
    return (addressBook === null || addressBook === void 0 ? void 0 : addressBook.currentlyEditingId) ? addressBook === null || addressBook === void 0 ? void 0 : addressBook.pendingListChanges[addressBook.currentlyEditingId] : undefined;
});

export { getAddCall, getAddressBook, getAddressBookList };
//# sourceMappingURL=selectors.js.map
